import { render, staticRenderFns } from "./BucketCard.vue?vue&type=template&id=90ce1290&"
import script from "./BucketCard.vue?vue&type=script&lang=js&"
export * from "./BucketCard.vue?vue&type=script&lang=js&"
import style0 from "./BucketCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports